import { getLoadablePage } from 'site-modules/shared/components/loadable-page/loadable-page';

export const routes = {
  path: '/car-reviews',
  exact: true,
  page: getLoadablePage(() => import(/* webpackChunkName: "car-reviews" */ '../pages/index/index-definition')),
  chunkName: 'car-reviews',
  resolveLocationInParallelToPagePreload: true,
  enableLooseEtag: true,
};
